import Vue from 'vue'

const SEARCH_ENDPOINT = 'offices/search'

const buildSearchParams = (filters, pagination) => {
  const params = {}

  if (filters) {
    const q = String(filters.q || '').trim()
    if (q) {
      params.q = q
    }

    if (filters.activation) {
      params.activation = filters.activation
    }

    if (Array.isArray(filters.services) && filters.services.length) {
      params.services = filters.services.join(',')
    }

    if (Array.isArray(filters.companies) && filters.companies.length) {
      params.companies = filters.companies.join(',')
    }
  }

  if (pagination) {
    params.page = pagination.page
    params.size = pagination.size
  }

  return params
}

const search = (filters, pagination) => {
  const params = buildSearchParams(filters, pagination)
  return Vue.prototype.$http.get(SEARCH_ENDPOINT, { params })
}

const fetchAll = (pagination) => {
  const params = buildSearchParams({}, pagination)
  return Vue.prototype.$http.get(SEARCH_ENDPOINT, { params })
}

const searchByZip = (zip) => {
  return Vue.prototype.$http.get('offices', { params: { zip } })
}

const fetchOne = (id) => {
  return Vue.prototype.$http.get(`offices/${id}`)
}

const update = (office) => {
  const officeId = office && (office.id || office.office_id)
  return Vue.prototype.$http.put(`offices/${officeId}`, office)
}

const activate = (officeId) => {
  return Vue.prototype.$http.put(`offices/${officeId}/activate`)
}

const deactivate = (officeId) => {
  return Vue.prototype.$http.put(`offices/${officeId}/inactivate`)
}

const exportOffices = (request) => {
  return Vue.prototype.$http.post('offices/export', request)
}

export default {
  search,
  fetchAll,
  searchByZip,
  fetchOne,
  update,
  activate,
  deactivate,
  exportOffices,
}
